import { animate, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'rl-error-page',
  styleUrls: ['./error-page.component.scss'],
  templateUrl: './error-page.component.html',
  animations: [
    trigger('errorContent', [
      transition(':enter', [
        style({ opacity: 0, 'margin-left': 0 }),
        animate('0.5s ease-out', style({ opacity: 1, 'margin-left': '30px' })),
      ]),
    ]),
  ],
})
export class ErrorPageComponent implements OnInit {
  @ViewChild('pageTitle', { static: true }) pageTitle: ElementRef;

  code: number | null;
  title: string | null;
  detail: string | null;

  constructor(
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title,
  ) {}

  get isReportableError(): boolean {
    return this.code >= 500 && this.code < 600;
  }

  ngOnInit() {
    const { queryParamMap } = this.activatedRoute.snapshot;
    this.code = Number.parseInt(queryParamMap.get('code'), 10) || null;
    this.title = queryParamMap.get('title') || null;
    this.detail = queryParamMap.get('detail') || null;

    this.titleService.setTitle(this.pageTitle.nativeElement.textContent.trim());

    this.hideElement('c-branded-header');
    this.hideElement('c-branded-footer');
  }

  private hideElement(className: string) {
    const element = this.document.querySelector(`.${className}`);
    if (element) {
      element.setAttribute('style', 'display: none !important');
    }
  }
}
